<template>
	<section>

		<!--Upcoming Events-->
		<!--Basic Box-->
		<div class="basic-box cabinet__basic-box">
			<div class="basic-box__title">Ближайшие события</div>

			<visit-item v-for="event in value" :key="event._id" :event="event"></visit-item>

			<div v-if="!value.length">У Вас еще нет событий</div>

			<!-- Button -->
			<div class="basic-box__btns text_center" v-show="value.length == 5">
				<button class="basic-box__btn btn_light-blue" @click="loadMore">
					Показать больше
					<i class="basic-box__icon_light basic-box__icon_arrow_down icon ion-chevron-down"></i>
				</button>
			</div>
			<!-- Button End -->

		</div>
		<!--Basic Box-->
		<!--Upcoming Events End-->

	</section>
</template>

<script>
	import VisitItem from '@/components/VisitItem.vue'

	export default {
		name: "ComingVisit",
		props: ['value'],
		components: {VisitItem},
		data() {
			return {
				count: 5
			}
		},
		methods: {
			loadMore() {
				this.count += 5
				this.$emit('more', this.count)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// ComingVisit.vue?19b6fae4